<script>
import styled from 'vue-styled-components';

const CookieBannerOption = styled.li`
  margin: .5rem 0;

    label {
      cursor: pointer;
      user-select: none;
    }

    input {
      display: none;
    }

    input + .__checkbox-wrapper .__checkbox {
      border: 1px solid ${(props) => props.theme.uncheckedCheckboxColor};
      width: ${(props) => props.theme.checkboxSize};
      height: ${(props) => props.theme.checkboxSize};
      border-radius: 50%;
      margin-right: 1rem;
      transition: all .25s;
      color: white;

      display: inline-flex;
      align-items: center;
      justify-content: center;

      i {
        transition: all .25s;
        font-size: calc(${(props) => props.theme.checkboxSize} - 7px);
        opacity: 0;
      }
    }

    input:checked + .__checkbox-wrapper .__checkbox {
      border: 1px solid ${(props) => props.theme.activeCheckboxColor};
      background-color: ${(props) => props.theme.activeCheckboxColor};

      i {
        opacity: 1;
      }
    }

    input[disabled]:checked + .__checkbox-wrapper .__checkbox {
      border: 1px solid ${(props) => props.theme.uncheckedCheckboxColor};
      background-color: ${(props) => props.theme.uncheckedCheckboxColor};      
      
      i {
        opacity: 1;
      }
    }

    input + .__checkbox-wrapper {
      display: flex;
      align-items: center;
    }

    input[disabled] + .__checkbox-wrapper {
      color: ${(props) => props.theme.uncheckedCheckboxColor};
    }
`;

export default CookieBannerOption;
</script>